import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { ThreeCircles } from 'react-loader-spinner';
import { Navigate, useLocation } from 'react-router-dom';
import auth from '../../firebase.init';

const RequireAuth = ({children}) => {
    const [user,loading] = useAuthState(auth);
    const location = useLocation();
    if(loading){
        return <ThreeCircles
        height="90"
        width="90"
        color="#4fa94d"
        wrapperStyle={{ 
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#000000"
        innerCircleColor="#ffeb3b"
        middleCircleColor="#000000"
      />
    }

    

    if(!user){
        return <Navigate to="/login" state={{ from: location }} replace></Navigate>
    }
    return children;
};

export default RequireAuth;